import {useLocation} from "react-router-dom";

export function useIsUserManagement() {
    const location = useLocation();
    return location.pathname.startsWith('/user-management');
}